import { render, staticRenderFns } from "./CompensationProcedureCreateModal.vue?vue&type=template&id=18e8177a"
import script from "./CompensationProcedureCreateModal.vue?vue&type=script&lang=js"
export * from "./CompensationProcedureCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports